import GridTile from "../model/grid/GridTile";
import BigNum from "../model/math/BigNum";
import NumberValue from "../model/value/NumberValue";
import { Settings } from "../Settings";
import Rand from "./Rand";

export default class ValueCalculator {
    constructor() {        
    }

    // static testAdditiveUpgrades() {

    //     let row = 1;
    //     let description = getLayerDescriptionForRow(row);
    //     while (description != null) {

    //         this.testCalcAdd(row, description);

    //         row += 25;
    //         if (row > 40000) {
    //             break;
    //         }
    //         description = getLayerDescriptionForRow(row);
    //     }
    // }

    // static testCalcAdd(row, layerDescription) {

    //     const randomFactor = (40 + Rand.randomInt(60)) / 100; // 40%-100%
    //     const additiveBonusFactor = layerDescription.additiveBonusFactor * randomFactor;

    //     console.log('row=' + row 
    //         + ' layerDescription.additiveBonusFactor=' + layerDescription.additiveBonusFactor 
    //         + ' additiveBonusFactor=' + additiveBonusFactor  + ' layer=' + layerDescription.name);

    // }

    /**
     * @param {GridTile} tile 
     * @returns {BigNum}
     */
    static calculateMinedDamageUpgradeValue(tile) {

        const randomFactor = (80 + Rand.randomInt(20)) / 100;  // 80%-100%

        return new BigNum(tile.tileType.layerDescription.multiplicativeBonusFactor * randomFactor);
    }

    /**
     * @param {NumberValue} damageUpgrades 
     * @returns {number}
     */
    static getDamageMultiplier(damageUpgrades) {
        // 25% bonus per damage upgrade. 
        return 1.0 + (Settings.skill.common.damagePerUpgrade * damageUpgrades.getValue());
    }

    /**
     * @param {NumberValue} damageUpgrades 
     * @returns {number}
     */
    static getDamagePercent(damageUpgrades) {
        // 25% bonus per damage upgrade. 
        return (Settings.skill.common.damagePercentPerUpgrade * damageUpgrades.getValue());
    }

    /**
     * @param {NumberValue} durationUpgrades 
     * @returns {number}
     */
    static getSkillActivationTurns(durationUpgrades) {
        return Settings.skill.common.baseActivationTurns + (durationUpgrades.getValue() * Settings.skill.common.activationTurnsPerUpgrade);
    }

    /**
     * @param {NumberValue} durationUpgrades 
     * @returns {number}
     */
    static getSkillActivationSeconds(durationUpgrades) {
        return this.getSkillActivationTurns(durationUpgrades) * Settings.time.secondsPerTurn;
    }

    /**
     * @param {NumberValue} coolDownUpgrades 
     * @returns {number}
     */
    static getSkillCoolDownTurns(coolDownUpgrades) {
        // Don't let the cool down turns become negative. 
        const upgradedTurns = coolDownUpgrades.getValue() * Settings.skill.common.coolDownTurnsPerUpgrade;
        return Math.max(8, Settings.skill.common.baseCoolDownTurns - upgradedTurns);
    }

    /**
     * @param {NumberValue} coolDownUpgrades 
     * @returns {number}
     */
    static getSkillCoolDownSeconds(coolDownUpgrades) {
        return this.getSkillCoolDownTurns(coolDownUpgrades) * Settings.time.secondsPerTurn;
    }

    /**
     * @param {NumberValue} missilesUpgrades 
     * @returns {number}
     */
    static getMissileCount(missilesUpgrades) {
        return Settings.skill.missiles.initialMissiles + (Settings.skill.missiles.missilesPerUpgrade * missilesUpgrades.getValue());
    }

    /**
     * @param {number} fallSpeedUpgrades 
     * @returns {number}
     */
    static getFallSpeedMultiplier(fallSpeedUpgrades) {
        return 1 + (fallSpeedUpgrades * Settings.skill.bonus.fallSpeedMuliplierPerUgrade)
    }
}